import { ConclusionKeys, FindingAreasEnum, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireLoans = {
    id: FindingAreasEnum.Loans,
    name: getFindingAreaDisplayText(FindingAreasEnum.Loans),
    questions: [
        {
            id: `${FindingAreasEnum.Loans}:Q1`,
            text: "Do you provide loans >£10k to employees or directors (this includes any director loan accounts)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Loans}:Q2`,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.Loans}:Q2`,
            text: "Do you charge interest on these loans equivalent to HMRC official rate and, is this paid by the employee (rather than accured)?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Loans}:Q3A`,
                no: `${FindingAreasEnum.Loans}:Q3B`,
            },
        },
        {
            id: `${FindingAreasEnum.Loans}:Q3A`,
            text: "Have you written off or waived a loan to a director/employee and not reported this for  income tax and National Insurance Contributions (\"NIC\") purposes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.Loans}:Q3B`,
            text: "Do you report the loans on Form P11D or via payroll?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.Loans}:Q4A`,
                no: `${FindingAreasEnum.Loans}:Q4B`,
            },
        },
        {
            id: `${FindingAreasEnum.Loans}:Q4A`, //Note: Q4A and Q4B are the same
            text: "Have you written off or waived a loan to a director/employee and not reported this for income tax and National Insurance Contributions (\"NIC\") purposes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Green,
            },
        },
        {
            id: `${FindingAreasEnum.Loans}:Q4B`,
            text: "Have you written off or waived a loan to a director/employee and not reported this for income tax and National Insurance Contributions (\"NIC\") purposes?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Amber,
            },
        }
    ],
};

export default questionnaireLoans;